export const Constants = {
  EMPTY_TEXT: '',
  LIGHT_MODE: 'light',
  EMPTY_NUMBER: 0,
  ASCII_BEFORE_A: 64,
  FIRST_SHEET_INDEX: 0,
  FIRST_ELEMENT_INDEX: 0,
  FIRST_CELL: 'A1'
};
